import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getOutlyingIslandsStores } from '@/constants/where-to-buy';
import NextImage from '@/components/NextImage';
import EFPhone from '@/components/UI/svg/WTB/EFPhone';
import EFClock from '@/components/UI/svg/WTB/EFClock';
import EFGlobal from '@/components/UI/svg/WTB/EFGlobal';
import EFLocation from '@/components/UI/svg/WTB/EFLocation';
import EFPageArrow from '@/components/UI/svg/WTB/EFPageArrow';

export default function PRHIVK() {
    const { useRouter, useState, useLang } = useGlobal();
    const { t } = useLang('wheretobuy');
    const { locale } = useRouter();
    const storesAll = getOutlyingIslandsStores(locale);
    const [curPage, setCurPage] = useState(1);
    const PAGE_NUM = 6;
    const [stores, setStores] = useState(storesAll?.slice(PAGE_NUM * (curPage - 1), PAGE_NUM * curPage));

    const onPrevPage = () => {
        if (curPage > 1) {
            window.scrollTo({ top: 150 });
            setCurPage(curPage - 1);
            setStores(storesAll.slice(PAGE_NUM * (curPage - 2), PAGE_NUM * (curPage - 1)));
        }
    };

    const onNextPage = () => {
        if (curPage < Math.ceil(storesAll.length / PAGE_NUM)) {
            window.scrollTo({ top: 150 });
            setCurPage(curPage + 1);
            setStores(storesAll.slice(PAGE_NUM * curPage, PAGE_NUM * (curPage + 1)));
        }
    };

    return (
        <div className={`${css['PRHIVK']}`}>
            <ul className="store-lists">
                {stores?.map((store: any, k: number) => (
                    <li className="store-list" key={k}>
                        <div className="list-img-box">
                            <NextImage
                                src={require(`@publicLocal/where-to-buy/pc/${store.img}`)}
                                width={548}
                                height={64}
                                alt={store.storeName}
                                aria-label={store.storeName}
                                placeholder="blur"
                            />
                            <p className="list-state">{store.state}</p>
                        </div>
                        <div className="list-text-box">
                            <p className="list-store-name">{store.storeName}</p>
                            {store?.address && !store?.virtualFlag && (
                                <div className="store-address common">
                                    <div className="icon">
                                        <EFLocation />
                                    </div>
                                    {store?.address.trim().startsWith('https://') ? (
                                        <a className="text" href={store?.link} target="_blank" rel="noreferrer">
                                            {store?.address}
                                        </a>
                                    ) : (
                                        <div className="text">{store?.address}</div>
                                    )}
                                </div>
                            )}
                            {store?.tel && (
                                <div className="store-tel common">
                                    <div className="icon">
                                        <EFPhone />
                                    </div>
                                    <a className="text" href={`tel:${store?.tel}`}>
                                        {store?.tel}
                                    </a>
                                </div>
                            )}
                            {store?.link && (
                                <div className="store-link common">
                                    <div className="icon">
                                        <EFGlobal />
                                    </div>
                                    <a className="text" href={store?.link} target="_blank" rel="noreferrer">
                                        {store?.link}
                                    </a>
                                </div>
                            )}
                            {store?.time && (
                                <div className="store-time common">
                                    <div className="icon">
                                        <EFClock />
                                    </div>
                                    <div className="text">{store?.time}</div>
                                </div>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
            {stores?.length > 0 && (
                <div className="pagenation">
                    <div className={`left-icon ${curPage === 1 ? 'disable' : ''}`} onClick={onPrevPage}>
                        <EFPageArrow />
                    </div>
                    <div className="middle-box">
                        <span className="pages">
                            {curPage}/{Math.ceil(storesAll.length / PAGE_NUM)}
                        </span>
                        <span className="total">
                            {storesAll.length === 1
                                ? t.rich('total_single', {
                                      total: storesAll.length,
                                  })
                                : t.rich('total', {
                                      total: storesAll.length,
                                  })}
                        </span>
                    </div>
                    <div className={`right-icon ${curPage === Math.ceil(storesAll.length / PAGE_NUM) ? 'disable' : ''}`} onClick={onNextPage}>
                        <EFPageArrow />
                    </div>
                </div>
            )}
        </div>
    );
}
